import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BestSellers.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const BestSellers = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const getImageUrl = (imgPath) => {
    if (!imgPath) return null;
    if (imgPath.startsWith('http')) return imgPath;
    const base = API_URL.replace('/api', '');
    if (imgPath.startsWith('/uploads/')) return `${base}${imgPath}`;
    return `${base}/api/images/${imgPath}`;
  };

  useEffect(() => {
    fetch(`${API_URL}/bestsellers`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setProducts(data.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const formatPrice = (min, max) => {
    const m = parseFloat(min), x = parseFloat(max);
    if (m === x) return `$${m.toFixed(2)}`;
    return `$${m.toFixed(2)} – $${x.toFixed(2)}`;
  };

  return (
    <div className="bestsellers-page">
      <div className="bestsellers-container">
        <div className="bestsellers-header">
          <h1>Best Sellers</h1>
          <p>Our most popular products, hand-picked for you</p>
        </div>

        {loading ? (
          <div className="bestsellers-loading">
            <div className="spinner"></div>
            <p>Loading best sellers...</p>
          </div>
        ) : products.length === 0 ? (
          <div className="bestsellers-empty">
            <p>No best sellers yet. Check back soon!</p>
            <button onClick={() => navigate('/shop')} className="btn-shop-all">Shop All Products</button>
          </div>
        ) : (
          <div className="bestsellers-grid">
            {products.map((p) => (
              <div
                key={p.product_group_id}
                className="bestseller-card"
                onClick={() => navigate(`/product-group/${p.group_id}`)}
              >
                <div className="bestseller-image">
                  {p.hero_image ? (
                    <img src={getImageUrl(p.hero_image)} alt={p.title} />
                  ) : (
                    <div className="no-image">No Image</div>
                  )}
                  {!p.in_stock && <span className="oos-badge">Out of Stock</span>}
                </div>
                <div className="bestseller-info">
                  {p.vendor_name && <p className="bestseller-vendor">{p.vendor_name}</p>}
                  <h3 className="bestseller-title">{p.title}</h3>
                  <div className="bestseller-price">{formatPrice(p.min_price, p.max_price)}</div>
                  {p.total_variants > 1 && (
                    <p className="bestseller-variants">{p.total_variants} options</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BestSellers;
